@if (csvTemplate) {
  <p>{{ translationService.getCsvCustomFieldsHelpText() }}</p>
  <mat-nav-list>
    <h2>
      {{ translationService.getTemplateNameFieldsText(csvTemplate.name) }}
    </h2>
    @if (csvTemplate) {
      @for (
        field of fields;
        track field.name;
        let i = $index;
        let last = $last
      ) {
        <a
          mat-list-item
          (keydown)="onKeydown($event, i)"
          [attr.tabindex]="i === 0 ? 0 : -1"
        >
          <span matListItemTitle class="soc-name"
            ><span class="bold"
              >{{ translationService.getSystemFieldText() }}:</span
            >
            {{ field.systemField }}</span
          >
          <span matListItemLine
            ><span class="bold"
              >{{ translationService.getUserDefinedFieldText() }}:</span
            >
            {{ field.alias }}</span
          >
        </a>
        @if (!last) {
          <mat-divider></mat-divider>
        }
      }
    }
  </mat-nav-list>
}
